import { createAsyncThunk } from '@reduxjs/toolkit';
import { getArchivedDiscountsData } from 'services/archivedDiscounts';
import { AppDispatch } from 'redux/store';

export const fetchArchivedDiscountsThunk = createAsyncThunk<
  Awaited<ReturnType<typeof getArchivedDiscountsData>>,
  void,
  { rejectValue: string }
>(
  'archivedDiscounts/fetchArchivedDiscounts',
  async (_, { rejectWithValue, dispatch: thunkDispatch }) => {
    const dispatch = thunkDispatch as AppDispatch;
    try {
      return await getArchivedDiscountsData(dispatch);
    } catch (error) {
      return rejectWithValue('Failed to load Archived Discounts');
    }
  },
);
